export default __webpack_public_path__ + "static/media/books2-afterA-480w.4318716b.png";